module.exports = __webpack_public_path__ + "static/media/banner_homepage_bg.e83ba6b6.jpg";